import axios from "axios";
import { getBaseDomainFromApiUrl } from "./helpers/domainHelper";

export var Config = (function () {
  let domain = "";
  let logoId = "";
  let baseDomain = "";
  let messageErrorCommunication = "";
  let language = "en";
  let license = {
    domains: "",
    expiryDate: "",
    key: "",
  };
  let InIframe = true;
  let messageParent = false;

  if (typeof window !== "undefined") {
    InIframe = window.self !== window.top;
    const params = new URLSearchParams(location.search);
    const paramLogo = params.get("logo");
    messageParent = !!params.get("messageParent");

    // Use API_URL to determine baseDomain instead of the env parameter from URL
    const apiUrl = process.env.API_URL;
    baseDomain = getBaseDomainFromApiUrl(apiUrl);

    // Extract domain for backward compatibility
    try {
      const url = new URL(baseDomain);
      domain = url.hostname.replace(".maatai.com", "");
    } catch {
      domain = "app";
    }

    if (paramLogo != "" && paramLogo != "null") {
      logoId = paramLogo;
    }
    fetchDate();
    fetchKey();
    language = window.navigator.language.includes("es") ? "es" : "en";

    messageErrorCommunication =
      language == "en"
        ? "A failed conection has been found. \n" +
          "Please close this tab and follow the instructions of the previous one."
        : "Se ha registrado una desconección con tu aplicación. \n" +
          "Por favor cierra esta pestaña y sigue las instrucciones indicadas en la ventana anterior.";

    async function fetchDate() {
      try {
        const { data } = await axios.get(
          `${baseDomain}/api/v3/setting/get?key=face_tec_license_expiration_date`,
        );
        license["expiryDate"] = data.data.setting.Value;
      } catch (error) {
        console.log("=== ERROR ===");
        console.log(error);
      }
    }

    async function fetchKey() {
      try {
        const { data } = await axios.get(
          `${baseDomain}/api/v3/setting/get?key=face_tec_license_key`,
        );
        license["key"] = data.data.setting.Value;
      } catch (error) {
        console.log("=== ERROR ===");
        console.log(error);
      }
    }
  }

  // FaceTec (SDK 10+): device key, `${API_URL}/facetec/process-request`, API key headers (.env)
  var DeviceKeyIdentifier = process.env.FACETEC_DEVICE_KEY_IDENTIFIER || "";
  var apiUrlForFaceTec = (process.env.API_URL || "").replace(/\/$/, "");
  var FaceTecProcessRequestURL = apiUrlForFaceTec
    ? `${apiUrlForFaceTec}/facetec/process-request`
    : "";
  var ApiKeyName = process.env.FACETEC_API_KEY_NAME || "";
  var ApiKeyValue = process.env.FACETEC_API_KEY_VALUE || "";

  return {
    DeviceKeyIdentifier,
    license,
    logoId,
    messageErrorCommunication,
    language,
    domain,
    baseDomain,
    InIframe,
    messageParent,
    FaceTecProcessRequestURL,
    ApiKeyName,
    ApiKeyValue,
  };
})();
